import { FC } from 'react';

import useStore from '../store/useStore';

const SendosoPane: FC = () => {
  const toRecipients = useStore(store => store.action.toRecipients);
  const toRecipient = toRecipients ? toRecipients[0] : null;

  return (
    <div className="flex-1">
      <iframe
        className="h-full w-full ml-[16px]"
        title="sendoso-action"
        src={`https://app.sendoso.com/plugin/plugin_integrations?email=${toRecipient?.email}`}
      />
    </div>
  );
};

export default SendosoPane;
